import { UserPlus, Link2, LineChart } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    number: "1",
    title: "Crie sua conta",
    description:
      "Cadastre-se gratuitamente em menos de 1 minuto. Sem cart\u00e3o de cr\u00e9dito.",
  },
  {
    icon: Link2,
    number: "2",
    title: "Conecte suas finan\u00e7as",
    description:
      "Adicione suas contas, cart\u00f5es e registre suas primeiras transa\u00e7\u00f5es.",
  },
  {
    icon: LineChart,
    number: "3",
    title: "Acompanhe e planeje",
    description:
      "Visualize relat\u00f3rios, defina metas e tome decis\u00f5es financeiras mais inteligentes.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Como funciona
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Comece a organizar suas finan&ccedil;as em 3 passos simples.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
            {/* Connecting line (desktop only) */}
            <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-border" />

            {steps.map((step) => (
              <div key={step.number} className="relative text-center space-y-4">
                {/* Step number circle */}
                <div className="relative mx-auto">
                  <div className="h-16 w-16 rounded-full bg-primary flex items-center justify-center mx-auto shadow-lg relative z-10">
                    <step.icon className="h-7 w-7 text-primary-foreground" />
                  </div>
                  <div className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-primary/20 flex items-center justify-center text-xs font-bold text-primary z-20">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-xl font-semibold text-foreground">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
